module.exports = __webpack_public_path__ + "static/media/11NEPAD4.36e18465.jpg";